<template>
  <header class="wizard__header">
    <v-layout>
      <v-spacer />
      <v-menu offset-y>
        <v-btn slot="activator" flat>
          <v-icon color="gray-6">account_circle</v-icon>
          <span class="toolbar__button-label text-capitalize">
            {{ name }}
          </span>
          <v-icon color="gray-6" class="autocomplete__arrow" right small>keyboard_arrow_down</v-icon>
        </v-btn>

        <v-list class="v-list--custom">
          <v-list-tile @click="logoutSession">
            <v-list-tile-title>{{ $t('Common.logout') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapState({
      name: ({ session }) => session.user.business.name
    })
  },
  data () {
    return {
      namespace: 'Views.Wizard.form'
    }
  },
  methods: {
    ...mapActions({
      logout: 'session/logout',
      clearSelectedCompany: 'company/clearSelectedCompany',
      clearUserClaims: 'userClaims/clear',
      clearCostCenterCounter: 'costCenter/clear'
    }),

    logoutSession () {
      this.logout()
      this.clearSelectedCompany()
      this.clearUserClaims()
      this.clearCostCenterCounter()

      if (window.Botkit) {
        window.removeEventListener('message', window.Botkit.receiveMessage, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard__header {
  left: 0;
  padding: 5px 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
